import React, { useState } from "react";
import axios from "axios";

const LoginDialog = ({ onLogin }) => {
  const [form, setForm] = useState({ firstName: "", empCode: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  try {
    // ✅ Get all users from API
    const res = await axios.get("https://crm-server-htk6.vercel.app/api/users");
    const users = res.data;

    // ✅ Check if a user exists with same firstname, empCode, password
    const foundUser = users.find(
      (u) =>
        u.firstName === form.firstName &&
        u.empCode === form.empCode &&
        u.password === form.password
    );

    if (foundUser) {
      // ✅ Check if already logged in
      // if (foundUser.loginStatus === true) {
      //   setError("⚠️ You are already logged in on another system.");
      //   return;
      // }

      // ✅ Update loginStatus = true
      await axios.put(`https://crm-server-htk6.vercel.app/api/users/${foundUser._id}`, {
        loginStatus: true,
      });

      onLogin({ ...foundUser, loginStatus: true }); // pass updated user back to App

      // ✅ Speak greeting
     // speakGreeting(foundUser.firstName);

    } else {
      setError("❌ Invalid username, empCode, or password");
    }
  } catch (err) {
    console.error("❌ Error in login:", err);
    setError("❌ Error connecting to server");
  }
};
// function speakGreeting(firstName) {
//   const hour = new Date().getHours();
//   let greeting = "";

//   if (hour < 12) greeting = "Good Morning";
//   else if (hour < 18) greeting = "Good Afternoon";
//   else greeting = "Good Evening";

//   const message = `Hello ${firstName}, ${greeting}. Welcome to CRM Application`;

//   const utterance = new SpeechSynthesisUtterance(message);
//   utterance.rate = 1;
//   utterance.pitch = 1;
//   utterance.volume = 1;

//   // ✅ Ensure voices are loaded
//   const setVoiceAndSpeak = () => {
//     const voices = speechSynthesis.getVoices();
//     // Pick a voice if you like, or let browser default
//     utterance.voice = voices.find(v => v.lang === "en-US") || voices[0];
//     speechSynthesis.speak(utterance);
//   };

//   if (speechSynthesis.getVoices().length === 0) {
//     speechSynthesis.onvoiceschanged = setVoiceAndSpeak;
//   } else {
//     setVoiceAndSpeak();
//   }
// }




  return (
    <div className="login-overlay">
      <div className="login-box">
        <h2>CRM Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="firstName"
            placeholder="User Name"
            value={form.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="empCode"
            placeholder="Employee Code"
            value={form.empCode}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <button type="submit">Login</button>
        </form>
        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
};

export default LoginDialog;
